import React from "react";
var TrackClientIdError;
(function (TrackClientIdError) {
    TrackClientIdError["Empty"] = "empty";
    TrackClientIdError["NotExists"] = "Client with this ID does not exist";
})(TrackClientIdError || (TrackClientIdError = {}));
var mapErrorToMessage = function (key) {
    var _a;
    if (!key)
        return "";
    return (_a = {},
        _a[TrackClientIdError.Empty] = "Введите название",
        _a[TrackClientIdError.NotExists] = "Клиента с таким ID не существует",
        _a)[key];
};
export var useClientIdEdit = function (initial) {
    var _a = React.useState(initial), clientId = _a[0], setClientId = _a[1];
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var validate = function () {
        var key = null;
        setError(key);
        return key === null;
    };
    return {
        value: clientId,
        set: setClientId,
        error: {
            value: Boolean(error),
            set: setError,
            key: error,
            message: mapErrorToMessage(error),
        },
        validate: validate,
    };
};
